var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.12.21a.73.73 0 0 1 0 1L2.49 6.77h14.78a.73.73 0 0 1 0 1.46H2.49l5.63 5.55a.71.71 0 0 1 0 1 .72.72 0 0 1-1 0L.31 8.1a.91.91 0 0 1-.17-.17L.21 8a.31.31 0 0 1-.09-.1v-.06a.53.53 0 0 1 0-.16A.41.41 0 0 1 0 7.5a.72.72 0 0 1 .31-.6L7.1.21a.72.72 0 0 1 1.02 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.f17fd1da4cf4111e431f963355f22e3b.svg";
export { ForwardRef as ReactComponent };